













import Vue from 'vue'
import { range } from 'lodash'
import moment from 'moment'

import { AllCasesQuery } from '@/graphql-schema'
import { NotNull, Unpacked } from '@/utils'
import { MyDate } from '@/store/workflow/types'

type Case = Unpacked<NotNull<AllCasesQuery['cases']>['nodes']>
type Appointment = Unpacked<NotNull<Case['myDates']>['nodes']>

export default Vue.extend({
  computed: {
    appointments(): moment.Moment[] {
      const dates: MyDate[] = this.$store.getters['workflow/myDates']
      return dates.map(d => moment(d.timestamp).locale(this.$i18n.locale))
    },
    days(): moment.Moment[] {
      return range(0, 7).map((days: number) =>
        moment()
          .add(days, 'days')
          .locale(this.$i18n.locale)
      )
    },
    noTerms(): boolean {
      return this.appointments.length === 0
    },
    nextAppointment(): moment.Moment | null {
      const now = moment()
      const futureAppointments = this.appointments.filter(appointment => appointment.isAfter(now))
      if (futureAppointments.length > 0) {
        return futureAppointments[0]
      } else {
        return null
      }
    },
  },
  methods: {
    hasAppointment(day: moment.Moment): boolean {
      return this.appointments.some(appointment => {
        return day.isSame(appointment, 'date')
      })
    },
  },
})
